import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaStar, FaHeart, FaShoppingCart, FaUser } from 'react-icons/fa';
import { Helmet } from "react-helmet";

const postsData = {
  1: {
    id: 1,
    title: 'A fenntartható kert alapjai: Talaj-előkészítés lépésről lépésre',
    category: 'Talaj és komposzt',
    image: '/images/1.jpg',
    author: 'Kertész Anna',
    date: '2025. január 10.',
    rating: '4.9',
    excerpt: 'Ismerje meg a természetes talajjavítás titkait, a komposztálást és a talajélet fontosságát a fenntartható kert kialakításában.',
    content: `
      <p>A fenntartható kertészet alapja a megfelelően előkészített talaj. A talaj nem csupán a növények rögzítésére szolgál, hanem egy élő, komplex ökoszisztémát alkot, amely tele van mikroorganizmusokkal, gombákkal és apró élőlényekkel. Az egészséges talaj kulcsfontosságú a sikeres kertészkedéshez.</p>
      <h2>Miért fontos a talaj előkészítése?</h2>
      <p>A talaj szerkezete meghatározza, hogy a növények milyen hatékonyan tudják felvenni a tápanyagokat és a vizet. A jól előkészített talaj biztosítja a megfelelő levegőzést, vízelvezetést és tápanyag-ellátást. A rosszul előkészített talaj gyökérrothadáshoz, tápanyaghiányhoz és gyenge növekedéshez vezethet.</p>
      <h3>Komposztálás otthon</h3>
      <p>A komposztálás nagyszerű módja a konyhai és kerti hulladékok hasznosításának. A komposzt értékes szerves anyagokat juttat vissza a talajba, javítva annak szerkezetét és táplálva a talajéletet. A jó komposzt gazdag nitrogénben, foszforban és káliumban.</p>
      <h3>A talaj életet támogató szerepe</h3>
      <p>A talajban élő mikroorganizmusok lebontják a szerves anyagokat, így szabadítják fel a tápanyagokat a növények számára. A gombahálózatok segítenek a növényeknek a víz és tápanyagok felszívásában. A talajlakó élőlények, mint a földigiliszták, javítják a talaj szerkezetét és aerációját.</p>
      <h2>Talajjavítási technikák</h2>
      <p>A talajjavítás nem egy egyszeri feladat, hanem folyamatos gondozást igényel. Íme néhány hatékony módszer:</p>
      <ul>
        <li>Rendszeres komposztálás és mulcsozás</li>
        <li>Zöldtrágya növények vetése</li>
        <li>Természetes talajlazítás a vakondok és földigiliszták támogatásával</li>
        <li>Savanyú vagy lúgos talaj esetén megfelelő savszabályzó anyagok alkalmazása</li>
        <li>Vegyszermentes tápanyagpótlás szerves trágyákkal</li>
      </ul>
      <p>A fenntartható kertészkedés nem igényel drága felszerelést vagy vegyszereket, csupán odafigyelést és türelmet. Kezdje kicsiben, és kertje hálás lesz a gondoskodásért. A talaj a kert alapja, ezért mindig fordítson elegendő figyelmet annak állapotára és egészségére.</p>
    `
  },
  2: {
    id: 2,
    title: 'Szezonális növényápolási kalauz 2025-re',
    category: 'Szezonális tippek',
    image: '/images/2.jpg',
    author: 'Kertész Anna',
    date: '2025. január 8.',
    rating: '4.8',
    excerpt: 'Komplett idővonal a kerti teendőkről egész évre: tavaszi ültetéstől a téli védelemig.',
    content: `
      <p>A kertészkedés egyik legfontosabb része az időzítés. A megfelelő időben végzett munkák biztosítják növényeink egészségét és bőséges termését. Íme egy átfogó kalauz a teljes évre tervezett kerti teendőkről.</p>
      <h2>Tavaszi teendők (március-május)</h2>
      <p>A tavasz a nagy ültetés időszaka. Készítse elő az ágyásokat, adjon komposztot a talajhoz, és ültesse el a fagyérzékeny növényeket csak a fagyok elmúltával. A gyümölcsfák metszése is ebben az időszakban esedékes, kivéve az őszibarackot, amelyet nyáron metszenek.</p>
      <h2>Nyári teendők (június-augusztus)</h2>
      <p>Nyáron a rendszeres öntözés és a gyomlálás a legfontosabb feladat. Mulcsozással csökkentheti a víz elpárolgását és a gyomok növekedését. A folyamatosan virágzó növények ösztönözhetőek az elnyílt virágzatok eltávolításával.</p>
      <h2>Őszi teendők (szeptember-november)</h2>
      <p>Az ősz a takarítás és az előkészítés időszaka. Távolítsa el a lehullott leveleket, komposztálja azokat. Ültethessen hagymás virágokat a tavaszi virágzáshoz. Takarja a fagyérzékeny növényeket, és gondoskodjon a megfelelő téli védelemről.</p>
      <h2>Téli teendők (december-február)</h2>
      <p>Télen csökkentse az öntözés gyakoriságát, és védeje a növényeket a kemény fagyoktól. Használja ki a telet tervezésre, kertészeti könyvek, katalógusok tanulmányozására. A madarak etetése is télen válik különösen fontossá.</p>
      <h3>Havi bontású teendők</h3>
      <ul>
        <li>Január: Tervezés, vetőmagrendelés</li>
        <li>Február: Hidegágy előkészítés, korai vetések</li>
        <li>Március: Metszés, talaj-előkészítés</li>
        <li>Április: Fagyérzékenyek ültetése, gyomlálás</li>
        <li>Május: Virágos növények ültetése, palántázás</li>
        <li>Június: Rendszeres öntözés, sövénynyírás</li>
        <li>Július: Nyári metszés, évelők osztása</li>
        <li>Augusztus: Betakarítás, gyógynövények gyűjtése</li>
        <li>Szeptember: Őszi ültetések, komposztálás</li>
        <li>Október: Levélgyűjtés, talajtakarás</li>
        <li>November: Fagyvédelem, szerszámkarbantartás</li>
        <li>December: Téli védelem ellenőrzése, pihenés</li>
      </ul>
      <p>Ne feledje: a kertészkedés rugalmasságot igényel. Minden kert más, és az időjárás is változékony. Figyelje növényei jelzéseit, és igazítsa a teendőket az aktuális körülményekhez.</p>
    `
  },
  3: {
    id: 3,
    title: 'Évelő virágok: A legszebb választások kertjébe',
    category: 'Virágok',
    image: '/images/3.jpg',
    author: 'Molnár Péter',
    date: '2025. január 5.',
    rating: '4.7',
    excerpt: 'Fedezze fel a legszebb évelő növényeket, amelyek évekig díszítik kertjét minimális karbantartás mellett.',
    content: `
      <p>Az évelő virágok a kert lelkei. Több évig, sőt évtizedekig is virágoznak, évről évre egyre szebbek lesznek. A jól megválasztott évelők alig igényelnek gondozást, mégis bámulatos látványt nyújtanak.</p>
      <h2>Miért válasszon évelőket?</h2>
      <p>Az évelők nagy előnye, hogy hosszú távon gazdaságosabbak, mint az egynyári növények. Nem kell őket minden évben újraületek, így jelentős időt és munkát takarítanak meg. Emellett a kert természetesebb, érettebb megjelenést kölcsönöznek.</p>
      <h3>Kedvenc évelő fajtáink</h3>
      <p>A választék szinte végtelen, de van néhány igazán megbízható kedvenc, amelyekkel garantált a siker:</p>
      <ul>
        <li>Levendula: Illatos, napfénykedvelő, a száraz kertek királynője</li>
        <li>Kúpvirág: Nagy, mutatós virágai vándorlási időszakban a lepkéket is vonzza</li>
        <li>Astilbe: Árnyékos helyekre is kiváló, puffadt virágzata van</li>
        <li>Fürtös gyöngyike: Korai tavaszi virágzás, apró, harang alakú virágok</li>
        <li>Kerti bazsarózsa: Illatos, nagy virágok, hosszú élettartam</li>
        <li>Füzikefa: Fészkes virágzat, napfényes helyekre különösen alkalmas</li>
      </ul>
      <h2>Ültetési és gondozási tippek</h2>
      <p>Az évelők ültetésekor vegye figyelembe a növények fény-, víz- és talajigényét. A legtöbb évelő a jó vízelvezetésű, legalább napi 6 óra napsütésnek kitett helyet szereti. Ültetéskor gondoskodjon megfelelő tőtávolságról, mert a növények növekedhetnek.</p>
      <p>A virágzás meghosszabbítása érdekében az elnyílt virágzatokat rendszeresen távolítsa el. Ez serkenti az új virágok fejlődését. A tavaszi komposztálás és a nyári öntözés mellett az évelőknek többnyire nincs szükségük különösebb tápanyagpótlásra.</p>
      <p>Az évelők osztása néhány évente frissíti a növényeket, és lehetőséget ad a szaporításra is. A legjobb időszak az osztásra a kora tavasz vagy az ősz.</p>
    `
  },
  4: {
    id: 4,
    title: 'Öntözés okosan: Víz-megtakarítási technikák kertjében',
    category: 'Öntözés',
    image: '/images/4.jpg',
    author: 'Kovács Éva',
    date: '2025. január 3.',
    rating: '4.9',
    excerpt: 'Tudja meg, hogyan csökkentheti akár 50 százalékkal a vízfelhasználást kertje öntözésében modern és hagyományos módszerekkel.',
    content: `
      <p>A víz minden élőlény számára elengedhetetlen, és a kertészkedésben különösen fontos szerepet játszik. A klímaváltozás miatt azonban a víz egyre értékesebb erőforrássá válik. Szerencsére számos módszer létezik, amellyel jelentősen csökkenthető kertje vízfogyasztása anélkül, hogy a növények szépségét vagy egészségét károsítanánk.</p>
      <h2>Alapelvek a hatékony öntözéshez</h2>
      <p>A legfontosabb alapelv a talaj nedvességtartalmának megóvása és a párolgás csökkentése. Mulcsozással, megfelelő ültetéssel és öntözési technikákkal érhetjük el a legjobb eredményt.</p>
      <h3>Mulcsozás - a legjobb barát</h3>
      <p>A talajtakarás (mulcs) rendkívül hatékony módszer. A szerves mulcs, például a fakéreg, a szalma vagy a komposzt, csökkenti a párolgást, elnyomja a gyomokat, és tápanyagot is biztosít a talajnak. A mulcs réteg vastagsága 5-10 cm legyen.</p>
      <h3>Öntözési technikák</h3>
      <p>A csepegtető öntözés a leghatékonyabb rendszer, mivel közvetlenül a gyökérzónába juttatja a vizet, csökkentve a párolgási veszteséget. Az esőztető öntözőfejek helyett használjon földbe helyezett csepegtetőcsöveket.</p>
      <ul>
        <li>Csepegtető öntözés: vízmegtakarítás akár 50 százalék</li>
        <li>Hajnali vagy esti öntözés: csökkenti a párolgást</li>
        <li>Szivárogtató tömlők: lassú, egyenletes vízleadás</li>
        <li>Esővízgyűjtés: ingyenes és környezetbarát megoldás</li>
      </ul>
      <h2>Öntözőrendszer kialakítása</h2>
      <p>Az intelligens öntözőrendszerek érzékelőkkel figyelik a talaj nedvességtartalmát és az időjárást, így automatikusan igazítják az öntözést az aktuális igényekhez. Ez a beruházás hosszú távon megtérül.</p>
      <h2>Földbe ültetett víztartó kapszulák</h2>
      <p>Egy egyszerű trükk: üres műanyag palackokat lyukasszon meg, ásd a földbe a növények mellé, és a víz lassan szivárog a talajba. Különösen hatékony fiatal növényeknél és nyári hónapokban.</p>
      <p>A vízmegtakarítás nemcsak a bolygónknak, hanem a pénztárcánknak is jót tesz. Kezdje el még ma alkalmazni ezeket a technikákat, és kertje És a bolygó is hálás lesz érte.</p>
    `
  },
  5: {
    id: 5,
    title: 'Városi kertészet: Zöld oázis létrehozása erkélyen',
    category: 'Városi kert',
    image: '/images/5.jpg',
    author: 'Nagy István',
    date: '2025. január 1.',
    rating: '4.6',
    excerpt: 'Gyakorlati útmutató az erkélykertészethez: konténerek, függőleges kertek és mini veteményesek városi környezetben.',
    content: `
      <p>A városlakóknak sem kell lemondaniuk a kertészkedés öröméről. Még a legkisebb erkélyen is csodálatos zöld oázist hozhat létre, ahol pihenhet, friss fűszernövényeket termeszthet, és élvezheti a természet közelségét. A városi kertészet különösen népszerűvé vált az utóbbi években.</p>
      <h2>Kezdje a tervezéssel</h2>
      <p>Mielőtt növényeket vásárolna, alaposan mérje fel erkélyének adottságait: mekkora a felület, mennyi napfényt kap, milyen az égtáji tájolás. Ez döntő fontosságú a megfelelő növényválasztásnál.</p>
      <h3>Konténerek és edények</h3>
      <p>A konténeres kertészkedés rugalmasságot és egyszerűséget kínál. Válasszon méretes edényeket, amelyek biztosítják a gyökerek fejlődését. Ügyeljen a jó vízelvezetésre, és használjon megfelelő virágföldet.</p>
      <ul>
        <li>Függőleges kert: fali virágtartók, zsebes rendszerek</li>
        <li>Korláttartó kaspók: maximális helykihasználás</li>
        <li>Mobil kerti kocsi: könnyen mozgatható növények</li>
        <li>Fűszernövény spirál: esztétikus és praktikus</li>
      </ul>
      <h2>Növényválasztás erkélyre</h2>
      <p>Az erkély adottságaitól függően válasszon növényeket. Délkeleti fekvésű erkélyre napfénykedvelő növényeket, északi fekvésűre árnyéktűrőket válasszon. A fűszernövények, a saláták, a mini paradicsomok és a balkon muskátli kiváló választások.</p>
      <h2>Mini veteményes erkélyen</h2>
      <p>Bizonyos zöldségek és fűszerek kiválóan termeszthetők konténerben: bazsalikom, petrezselyem, menta, újhagyma, retek, eper. Rendszeres öntözéssel és tápanyagpótlással bőséges termésre számíthat.</p>
      <h3>Fontos a balkon kerti tippekhez</h3>
      <p>Gondoskodjon a megfelelő öntözésről, mivel az erkélyen a talaj gyorsabban kiszárad. Használjon talajtakarót a nedvesség megtartásához. Rendszeresen ellenőrizze a növényeket kártevők és betegségek szempontjából, és cselekedjen időben.</p>
      <p>A városi kertészet nemcsak hobbi, hanem életminőség-javító tevékenység is. A zöld növények csökkentik a stresszt, frissíti a levegőt, és kapcsolatot teremt a természettel még a város közepén is. Kezdjen neki még ma erkélykertészetnek!</p>
    `
  }
};

function PostDetail() {
  const { id } = useParams();
  const post = postsData[id] || postsData[1];
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);

  const handleFavorite = () => {
    setIsFavorite(!isFavorite);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 2000);
  };

  const handleShare = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 2000);
  };

  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="post-detail">
      <div className="post-detail-hero">
        <img src={post.image} alt={post.title} />
      </div>

      <article className="post-detail-header">
        <span className="post-card-category">{post.category}</span>
        <h1>{post.title}</h1>
        <div className="post-detail-meta">
          <span><FaUser /> {post.author}</span>
          <span>📅 {post.date}</span>
          <span><FaStar /> {post.rating} / 5 értékelés</span>
        </div>

        <div className="post-detail-body">
          <p style={{ fontSize: '1.2rem', fontStyle: 'italic' }}>{post.excerpt}</p>
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>

        <div className="post-actions">
          <button className="btn btn-accent" onClick={handleFavorite}>
            <FaHeart style={{ color: isFavorite ? 'red' : 'inherit' }} />
            {isFavorite ? 'A kedvencekben van' : 'Kedvencekhez adás'}
          </button>
          <Link to="/" className="btn btn-secondary">Vissza a főoldalra</Link>
        </div>
      </article>

      {showNotification && (
        <div className="notification">
          {isFavorite ? 'A bejegyzés hozzáadva a kedvencekhez' : 'A megosztási funkció hamarosan elérhető'}
        </div>
      )}

      <div className="about-section" style={{ marginTop: '40px', background: 'rgba(138,154,91,0.15)' }}>
        <h3>Hasonló bejegyzések</h3>
        <div className="features" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
          {Object.values(postsData).filter(p => p.id !== post.id).slice(0, 3).map(p => (
            <div key={p.id} className="feature-card">
              <Link to={`/post/${p.id}`}>
                <img src={p.image} alt={p.title} style={{ borderRadius: '10px', marginBottom: '15px', height: '150px', width: '100%', objectFit: 'cover' }} />
                <h3 style={{ fontSize: '1.1rem' }}>{p.title}</h3>
                <p style={{ fontSize: '0.9rem' }}>{p.excerpt.substring(0, 80)}...</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  
    </>);
}

export default PostDetail;